module.exports = __webpack_public_path__ + "static/media/visa.a63d5552.svg";